import React, { useEffect, useState } from 'react';
import { Alert, Card, Form, Button, Container, Row, Col } from 'react-bootstrap';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { resendPassword } from '../../../../core/store/auth/resetPassword/thunk';

const SendNewPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [token, setToken] = useState("");

  useEffect(() => {
    let tokenget = (searchParams.get("token") || "").trim().replace(/^\/\/\s*en\s*locale/, ''); 
    if (tokenget) {
      let tokenExtracted = tokenget.trim(); 
      localStorage.setItem("resetToken", tokenExtracted); // Stockage correct
      setToken(tokenExtracted);
    } else {
      let storedToken = localStorage.getItem("resetToken");
      if (storedToken) {
        setToken(storedToken);
      }
    }
  }, [searchParams]);

  console.log("Token reçu :", token);

  // Validation du formulaire avec Formik et Yup
  const formik = useFormik({
    initialValues: {
      newPassword: '',
      confirmationPassword: '',
    },
    validationSchema: Yup.object({
      newPassword: Yup.string()
        .min(6, 'Le mot de passe doit contenir au moins 6 caractères')
        .required('Le nouveau mot de passe est requis'),
      confirmationPassword: Yup.string()
        .oneOf([Yup.ref('newPassword'), null], 'Les mots de passe doivent correspondre')
        .required('La confirmation du mot de passe est requise'),
    }),
    onSubmit: (values) => {
      const { newPassword, confirmationPassword } = values;
      dispatch(resendPassword(token, newPassword, confirmationPassword, navigate));
    },
  });

  return (
    <Container className="d-flex align-items-center justify-content-center mt-5">
      <Row>
        <Col md={12}>
          <Card style={{ width: '44rem' }}>
            <Card.Header className="text-center">
              <h4>Réinitialiser votre mot de passe</h4>
            </Card.Header>
            <Card.Body>
              <p>Veuillez entrer votre nouveau mot de passe.</p>
              <Form onSubmit={formik.handleSubmit}>
                {/* Champ Nouveau Mot de Passe */}
                <Form.Group className="mb-3">
                  <Form.Label>Nouveau mot de passe</Form.Label>
                  <Form.Control
                    type="password"
                    name="newPassword"
                    value={formik.values.newPassword}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    isInvalid={formik.touched.newPassword && formik.errors.newPassword}
                    placeholder="Entrez votre nouveau mot de passe"
                  />
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.newPassword}
                  </Form.Control.Feedback>
                </Form.Group>

                {/* Champ Confirmation Mot de Passe */}
                <Form.Group className="mb-3">
                  <Form.Label>Confirmez le mot de passe</Form.Label>
                  <Form.Control
                    type="password"
                    name="confirmationPassword"
                    value={formik.values.confirmationPassword}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    isInvalid={formik.touched.confirmationPassword && formik.errors.confirmationPassword}
                    placeholder="Confirmez votre mot de passe"
                  />
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.confirmationPassword}
                  </Form.Control.Feedback>
                </Form.Group>

                {/* Boutons Annuler et Soumettre */}
                <div className="d-flex justify-content-between">
                  <Button variant="secondary" as={Link} to="/Verifiedemail">
                    Annuler
                  </Button>
                  <Button variant="primary" type="submit">
                    Soumettre
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SendNewPassword;
